import React from "react";
import { useQuery } from "@tanstack/react-query";
import { AnimatedPanel, SectionTitle, SectionDescription } from "./ui/StyledUI";
import { getAllNotes } from "../../../../features/guestbook/api/notesController";
import { CACHE_QUERY_OPTIONS } from "../../../../constants";

export default function Guestbook({ user, roomId }) {
    const [approved, setApproved] = React.useState(0);
    const [pending, setPending] = React.useState(0);

    const {
        data: notesData,
        error,
        isLoading,
        refetch: refetchNotes,
    } = useQuery(["notes", roomId], () => getAllNotes(roomId), {
        enabled: !!roomId,
        ...CACHE_QUERY_OPTIONS(),
    });

    React.useEffect(() => {
        if (notesData) {
            const approvedNotes = notesData.filter((note) => note.isApproved).length;
            const pendingNotes = notesData.filter((note) => !note.isApproved).length;
            setApproved(approvedNotes);
            setPending(pendingNotes);
        }
    }, [notesData]);

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <AnimatedPanel>
                <SectionTitle>Guestbook</SectionTitle>
                <SectionDescription>Manage the notes displayed in your guestbook.</SectionDescription>

                <div style={{ display: "flex", gap: 12, alignItems: "center", marginTop: 10 }}>
                    <div
                        style={{
                            padding: 12,
                            borderRadius: 10,
                            background: "rgba(255,255,255,0.02)",
                            border: "1px solid rgba(255,255,255,0.04)",
                        }}
                    >
                        <div style={{ fontWeight: 700 }}>Pending</div>
                        <div style={{ fontSize: 22 }}>{pending}</div>
                    </div>

                    <div
                        style={{
                            padding: 12,
                            borderRadius: 10,
                            background: "rgba(255,255,255,0.02)",
                            border: "1px solid rgba(255,255,255,0.04)",
                        }}
                    >
                        <div style={{ fontWeight: 700 }}>Published</div>
                        <div style={{ fontSize: 22 }}>{approved}</div>
                    </div>
                </div>
            </AnimatedPanel>
        </div>
    );
}

const btnStyle = {
    padding: "10px 14px",
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.06)",
    color: "#fff",
    borderRadius: 10,
    cursor: "pointer",
    fontWeight: 700,
};
